import { contact } from "@kanata/shared";

/** The Bahasa prompt shown when a made-to-order choice is selected. */
export const INQUIRY_CTA = "Segera chat Admin untuk konsultasi lebih lanjut";

/**
 * A WhatsApp deep link that arrives already knowing what the shopper wants.
 *
 * The alternative is the plain wa.link used for generic "message us" buttons,
 * but somebody who has just configured a custom 180cm walnut desk should not
 * have to describe it again — and the admin answering has no way to guess which
 * product the message is about. Built the way the contact form builds its own.
 */
export function inquiryWhatsappUrl(
  productName: string,
  selections: string[],
  url = `https://wa.me/${contact.whatsappDigits}`,
): string {
  const lines = [
    `Halo Kanata, saya mau tanya soal ${productName}.`,
    "",
    ...selections,
    "",
    "Boleh dibantu konsultasi?",
  ].filter((line, i, all) => line !== "" || all[i - 1] !== "");
  return `${url}?text=${encodeURIComponent(lines.join("\n"))}`;
}
